import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const bookingFields: FormField[] = [
	{
		name: "bookingDateFrom",
		label: "Data rozpoczęcia rezerwacji",
		type: FormRenderTypes.date,
		value: "",
		placeholder: "Data od",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "bookingDateTo",
		label: "Data zakończenia rezerwacji",
		type: FormRenderTypes.date,
		value: "",
		placeholder: "Data do",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "price",
		label: "Cena",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Cena rezerwacji",
		group: FormRenderGroupTypes.basic,
	},

	{
		name: "offerId",
		label: "Oferta",
		type: FormRenderTypes.autocomplete,
		value: "",
		placeholder: "ID oferty",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "numberOfParticipants",
		label: "Liczba uczestników",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Ilość uczestników",
		group: FormRenderGroupTypes.configuration,
	},

	{
		name: "published",
		label: "Opublikowana",
		type: FormRenderTypes.switch,
		value: "",
		placeholder: "Opublikowana",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "possibilityOfReservation",
		label: "Możliwość rezerwacji",
		type: FormRenderTypes.switch,
		value: "",
		placeholder: "Możliwość rezerwacji",
		group: FormRenderGroupTypes.configuration,
	},
	{
		name: "bookingStatusName",
		label: "Status rezerwacji",
		type: FormRenderTypes.select,
		value: "",
		placeholder: "Status",
		group: FormRenderGroupTypes.configuration,
	},

	// AutomaticBookingsDto
	{
		name: "startDate",
		label: "Data rozpoczęcia",
		type: FormRenderTypes.date,
		value: "",
		placeholder: "Wybierz datę rozpoczęcia",
		group: FormRenderGroupTypes.automatic,
	},
	{
		name: "durationInDays",
		label: "Czas trwania (dni)",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Ilość dni",
		group: FormRenderGroupTypes.automatic,
	},
	{
		name: "offsetDays",
		label: "Odstęp dni między rezerwacjami",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Opóźnienie (dni)",
		group: FormRenderGroupTypes.automatic,
	},
	{
		name: "numberOfBookings",
		label: "Liczba rezerwacji do wygenerowania",
		type: FormRenderTypes.number,
		value: "",
		placeholder: "Ilość rezerwacji",
		group: FormRenderGroupTypes.automatic,
	},
];
